const themeLightNotificationWarning = '#F3BE00';

export { themeLightNotificationWarning };
